
import {RefObject, useEffect} from 'react';

export const useOutsider = (
	refs: RefObject<HTMLDivElement>[],
	callback: (ev: MouseEvent) => void,
) => {
	// Handler checks if a click is contained and calls
	// the callback if there's an uncontained click
	const handleOutside = (ev: MouseEvent) => {
		for (const ref of refs) {
			if (!ref.current) {
				continue;
			} else if (ref.current.contains(ev.target as Node)) {
				return;
			}
		}
		callback(ev);
	};

	// Register the handler with the document and deregister on exit
	useEffect(() => {
		document.addEventListener('mousedown', handleOutside);
		return () => {
			document.removeEventListener('mousedown', handleOutside);
		};
	}, [refs, callback]);
};
